module.exports = __webpack_public_path__ + "static/img/gptModel11.df1a06fb.png";